module.exports = __webpack_public_path__ + "static/media/nqueens.7f3c1a9c.jpg";